/**
 * Constantes de couleurs pour les statuts de tâches
 * Classification moderne avec 5 catégories
 * Synchronisé avec WellfareMonitor2/app/views/tasks/constants/taskStatusColors
 */

export const TASK_STATUS_COLORS = {
  // Statut: Ouvert - tâche créée mais pas encore commencée
  OPEN: {
    primary: '#3B82F6',    // Bleu
    light: '#DBEAFE',
    text: '#1E40AF',
  },

  // Statut: Ouvert en retard - tâche ouverte dont l'échéance est dépassée (calculé côté client)
  OPEN_LATE: {
    primary: '#F97316',    // Orange
    light: '#FFEDD5',
    text: '#EA580C',
  },

  // Statut: En cours - tâche en cours de réalisation
  IN_PROGRESS: {
    primary: '#06B6D4',    // Cyan
    light: '#CFFAFE',
    text: '#0E7490',
  },

  // Statut: Terminé à l'heure - tâche complétée dans les délais
  DONE: {
    primary: '#10B981',    // Vert
    light: '#D1FAE5',
    text: '#047857',
  },

  // Statut: Terminé en retard - tâche complétée après la deadline
  DONE_LATE: {
    primary: '#B8B500',    // Kaki (brown-green, closer to green)
    light: '#E8DCC9',
    text: '#6B5530',
  },

  // Statut: Échoué - tâche non réalisée ou abandonnée
  FAILED: {
    primary: '#EF4444',    // Rouge
    light: '#FEE2E2',
    text: '#DC2626',
  },

  // Statut: Archivé
  ARCHIVED: {
    primary: '#6B7280',    // Gris
    light: '#F3F4F6',
    text: '#374151',
  },

  // Statut: Annulé
  CANCELLED: {
    primary: '#000000',    // Noir
    light: '#F3F4F6',
    text: '#FFFFFF',
  },
};

/**
 * Obtenir la couleur principale pour un statut donné
 * @param {string} status - Le statut de la tâche (OPEN, IN_PROGRESS, DONE, FAILED, etc.)
 * @param {boolean} isLate - Si la tâche est en retard (optionnel)
 * @returns {string} - Code couleur hexadécimal
 */
export const getStatusColor = (status, isLate = false) => {
  if (status === 'OPEN' && isLate) {
    return TASK_STATUS_COLORS.OPEN_LATE.primary;
  }
  if (status === 'DONE' && isLate) {
    return TASK_STATUS_COLORS.DONE_LATE.primary;
  }

  return TASK_STATUS_COLORS[status]?.primary || '#6B7280';
};

/**
 * Obtenir toutes les couleurs pour un statut donné
 * @param {string} status - Le statut de la tâche
 * @param {boolean} isLate - Si la tâche est en retard (optionnel)
 * @returns {object} - Objet contenant primary, light et text colors
 */
export const getStatusColors = (status, isLate = false) => {
  if (status === 'OPEN' && isLate) {
    return TASK_STATUS_COLORS.OPEN_LATE;
  }
  if (status === 'DONE' && isLate) {
    return TASK_STATUS_COLORS.DONE_LATE;
  }

  return TASK_STATUS_COLORS[status] || TASK_STATUS_COLORS.ARCHIVED;
};
